/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { WDHImage } from '@demant/wdh';
import { withReactBootstrap } from '@demant/wdh-react-bootstrap';
var BlogListApp = function BlogListApp(_ref) {
  var settings = _ref.settings;
  var list = settings.blogList;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "blog-list"
  }, list.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "blog-list-item",
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link.href,
      className: "blog-list-item-content",
      "data-videoembed": item.link.getAttribute('data-videoembed')
    }, /*#__PURE__*/React.createElement("div", {
      className: "news-image"
    }, /*#__PURE__*/React.createElement(WDHImage, {
      image: item.image
    })), /*#__PURE__*/React.createElement("div", {
      className: "blog-text-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "news-date"
    }, item.date), /*#__PURE__*/React.createElement("div", {
      className: "news-title"
    }, item.title), /*#__PURE__*/React.createElement("div", {
      className: "news-text"
    }, item.text), /*#__PURE__*/React.createElement("div", {
      className: "news-link"
    }, item.newsLink))));
  })));
};
export default withReactBootstrap(BlogListApp);